export default {"src":"/_next/static/media/lineGroupG.1bd854b5.svg","height":348,"width":1756,"blurWidth":0,"blurHeight":0};